const backendUrl = "https://apnaplaza-backend.vercel.app"; // Base URL from configuration
export default backendUrl;
